module.exports = {
  apiKey: 'AIzaSyDR-lRiW_vjGXgN_CNzXWJEcSHI6_wVRBE',
  authDomain: 'circuit-repair.firebaseapp.com',
  databaseURL: 'https://circuit-repair.firebaseio.com',
  projectId: 'circuit-repair',
  storageBucket: 'circuit-repair.appspot.com',
  messagingSenderId: '1057514731160',
  appId: '1:1057514731160:web:71511d2f9be7d34fb442ed',
  measurementId: 'G-SM6X56LDLZ'
}
